import React from 'react';

import { verificationUrl as verificationUrlPropType } from '../../userPropTypes.js';

const ConfirmIdentity = ({ verificationUrl }) => (
    <div>
        <p>
            For å godkjenne avtalen og gå videre med Trygg betaling må FINN vite
            hvem du er.
        </p>

        <div className="r-pal">
            <div className="r-mbm">
                <a href={verificationUrl} className="button primary fullwidth">
                    Bekreft din identitet
                </a>
            </div>
        </div>
    </div>
);

ConfirmIdentity.propTypes = {
    verificationUrl: verificationUrlPropType.isRequired,
};

export default ConfirmIdentity;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/confirmIdentity.jsx